import './ErrorAlert.css'

interface Props {
  message: string
  severity?: 'error' | 'warning' | 'info'
}

export function ErrorAlert({ message, severity = 'error' }: Props) {
  return (
    <div className={`alert alert--${severity}`} role="alert">
      <span className="alert__marker">!</span>
      <span className="alert__msg">{message}</span>
    </div>
  )
}
